<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-50 flex items-start justify-center pt-10 bg-black bg-opacity-50"
    @click="handleClickOutside"
  >
    <div
      class="relative w-3/4 h-auto p-6 overflow-y-auto bg-white rounded-lg"
      @click.stop
    >
      <div class="flex items-center justify-between mb-6">
        <h2 class="text-xl font-bold">{{ title }}</h2>
        <button
          type="button"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="closeModal"
          class="text-gray-500 transition duration-150 hover:text-gray-700"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <div class="grid gap-4 md:grid-cols-3 md:gap-6">
        <!-- Asset Details -->
        <div class="col-span-2 space-y-4 md:col-span-2">
          <div class="grid grid-cols-1 gap-2 sm:grid-cols-3">
            <div class="text-gray-700 sm:col-span-2">
              <h2 class="text-lg font-bold">{{ user?.name }}</h2>
            </div>
          </div>
        </div>
      </div>
      <form class="space-y-6" @submit.prevent="submit">
        <div
          class="flex flex-col space-y-4 md:flex-row md:space-x-4 md:space-y-0"
        >
          <div class="flex-1">
            <input type="text" v-model="form.userid" hidden />
            <InputLabel for="Asset" value="Role" class="mb-2" />
            <select
              name="aset"
              v-model="form.roleid"
              class="block w-full py-2 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            >
              <option value="">Pilih Role</option>
              <option
                v-for="role in roles.data"
                :key="role.id"
                :value="role.id"
              >
                {{ role.title }}
              </option>
            </select>
            <InputError :message="form.errors.roleid" class="mt-2" />
          </div>
        </div>
        <div class="flex justify-end space-x-4">
          <button
            type="button"
            @click="submit"
            class="px-4 py-2 mt-4 text-white bg-gray-800 rounded"
          >
            Simpan
          </button>
          <button
            type="button"
            @click="closeModal"
            class="px-4 py-2 mt-4 text-white bg-red-500 rounded"
          >
            Tutup
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, watch } from "vue";
import { useForm } from "@inertiajs/vue3";
import InputLabel from "./InputLabel.vue";
import InputError from "./InputError.vue";
import InputField from "./InputField.vue";
import Swal from "sweetalert2";

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  user: {
    type: Object,
    required: true,
  },
  roles: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["update:isOpen"]);

const form = useForm({
  roleid: "",
  userid: "",
});

watch(
  () => props.user,
  (userRole) => {
    if (userRole) {
      form.userid = userRole.id;
    }
  },
  { immediate: true, deep: true }
);

// Close modal function
const closeModal = () => {
  emit("update:isOpen", false);
};

// Handle clicking outside the modal to close it
const handleClickOutside = (event) => {
  if (event.target === event.currentTarget) {
    closeModal();
  }
};

const submit = () => {
  form.post(route("roleuser.store"), {
    onSuccess: () => {
      form.reset();
      Swal.fire({
        title: "Berhasil!",
        text: "Data berhasil disimpan.",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        // Update data atau tutup modal, menghindari reload
        emit("update:isOpen", false); // Menutup modal
      });
    },
    onError: (errors) => {
      Swal.fire({
        title: "Error!",
        text: "Data gagal disimpan. Periksa kembali input.",
        icon: "error",
        confirmButtonText: "OK",
      });
    },
  });
};
</script>

<style scoped></style>
